import { FormGroup } from './../../../../core/utils/form/form_builder/controls/FormGroup';
import { Observable } from 'rxjs';
import { createContext, useContext } from 'react';
import { CourseBuilderForm, CourseBuilderBlockForm } from './CourseBuilderForm';
import { CourseBuilderPreviewPageBloc } from '../CourseBuilderPreviewPage/CourseBuilderPreviewPageBloc';
import { CourseBuilderPageBloc } from './CourseBuilderPageBloc';
import { UserCourseStepResponse } from '@business/entities/user_course';
import { MultiplePreviewBlockBloc } from '../Blocks/BlockBase/MultiplePreviewBlock/MultiplePreviewBlockBloc';

interface CourseBuilderContextType {
  form: CourseBuilderForm;
  currentSection: number;
  bloc: CourseBuilderPageBloc | CourseBuilderPreviewPageBloc | MultiplePreviewBlockBloc;
  sidebar: boolean;
  toggleSidebar: () => void;
  lessonId?: string;
  registerForms?: (id: string, submit: () => Observable<boolean>) => void;
}

export const CourseBuilderContext = createContext<CourseBuilderContextType | null>(null);

export function useCourseBuilderContext() {
  return useContext(CourseBuilderContext);
}

interface CourseBuilderBlockContextType {
  blockForm: CourseBuilderBlockForm;
  blockIndex: number;
  step?: UserCourseStepResponse;
}

export const CourseBuilderBlockContext = createContext<CourseBuilderBlockContextType | null>(null);

export function useCourseBuilderBlockContext() {
  return useContext(CourseBuilderBlockContext);
}
